import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Proposals.css";

const Proposals = () => {
  const [proposalsHeader, setProposalsHeader] = useState([]);
  const [proposalsOwn, setProposalsOwn] = useState([]);
  const [proposalsPackage, setProposalsPackage] = useState([]);
  const [awardData, setAwardData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);

      try {
        const [proposalsRes, awardRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/images/proposals`),
          fetch(`${process.env.REACT_APP_API_URL}/api/images/main`),
        ]);

        if (!proposalsRes.ok) {
          throw new Error(
            proposalsRes.message || "Failed to fetch group images",
          );
        }
        if (!awardRes.ok) {
          throw new Error(awardRes.message || "Failed to fetch award images");
        }

        const proposalsData = await proposalsRes.json();
        const awardData = await awardRes.json();

        setProposalsHeader(proposalsData.data.header);
        setProposalsOwn(proposalsData.data.options);
        setProposalsPackage(proposalsData.data.package);
        setAwardData(awardData.data.award);
      } catch (err) {
        setError(err.message || "Failed to fetch image");
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  if (!proposalsHeader.length) return <div>No data</div>;

  return (
    <div className="proposals">
      <section className="proposals__intro--container">
        <div className="proposals__intro--header">
          <img
            src={proposalsHeader[0]?.src}
            alt={proposalsHeader[0]?.alt}
            className="proposals__intro--image"
          />
          <div className="proposals__intro--header-text">
            <h1>Proposals</h1>
            <p>Say “Yes” to Forever with the Perfect Proposal Picnic</p>
          </div>
          <div className="proposals_award--container-right">
            <img
              src={awardData[2]?.src}
              alt={awardData[2]?.alt}
              className="proposals__intro--image"
            />
          </div>
        </div>

        <div className="proposals__intro--content">
          <h2>The Proposal Picnic</h2>
          <p>
            At Bribie Island Picnics we believe every love story deserves a
            magical beginning. Our luxury picnic experiences are thoughtfully
            designed to turn life's most special moments into unforgettable
            memories and there's no moment more meaningful than a proposal.
          </p>
          <p>
            Surrounded by the natural beauty of Bribie Island we take care of
            every detail, so all you have to do is bring the ring and the love
            of your life. Let us help you pop the question in a way that's as
            unique and beautiful as your love story.
          </p>
        </div>
      </section>

      {/* Proposal Picnic Options */}
      <section className="proposals__container">
        {/* Personalised - Option 1 */}
        <div className="proposals__picnic--container">
          <div className="proposals__picnic--create-container">
            <div className="proposals___picnic--header">
              <h2>Create Your Own Proposal Picnic</h2>
            </div>
            <div className="proposals__picnic--details">
              <p>Let us help you bring your proposal vision to life.</p>
              <p>
                Choose any of our luxury couples picnic setting for two{" "}
                <strong> from $195 </strong>and add your preferred additions for
                your ultimate proposal.
              </p>
            </div>
            <div className="proposals__picnic--options">
              <Link
                to="/additions"
                className="proposals__picnic--options-btn my-btn"
              >
                Additions/Enhancements
              </Link>
            </div>
          </div>
          {/* Proposal Picnic Images 1 */}
          <div className="proposals__picnic--image-container">
            <img
              src={proposalsOwn[0]?.src}
              alt={proposalsOwn[0]?.alt}
              className="proposals__picnic--image"
            ></img>
            <img
              src={proposalsOwn[1]?.src}
              alt={proposalsOwn[1]?.alt}
              className="proposals__picnic--image"
            ></img>
            <img
              src={proposalsOwn[2]?.src}
              alt={proposalsOwn[2]?.alt}
              className="proposals__picnic--image"
            ></img>
            <img
              src={proposalsOwn[3]?.src}
              alt={proposalsOwn[3]?.alt}
              className="proposals__picnic--image"
            ></img>
          </div>
        </div>

        {/* Packaged - Option 2 */}
        <div className="proposals__picnic--container">
          <div className="proposals___picnic--header">
            <h2>Proposal Picnic Package</h2>
          </div>
          <div className="proposals__picnic--details">
            <p>
              Let us take care of your big moment with our carefully prepared
              Proposal Picnic Package that offers a beautifully styled, intimate
              setting that's both romantic and effortless.
            </p>
          </div>

          {/* Packaged details */}
          <div className="proposals__picnic--container-package">
            <div className="proposals__picnic--image-package">
              <img
                src={proposalsPackage[4]?.src}
                alt={proposalsPackage[4]?.alt}
              ></img>
            </div>
            <div>
              <div className="proposals__picnic--details-package">
                <div className="proposals___picnic--header-package">
                  <h2>The Proposal Picnic for 2 $600</h2>
                </div>
                <p>
                  Make your proposal truly unforgettable with our Signature
                  Proposal Picnic experience. Thoughtfully designed for romance
                  and intimacy, this luxurious setting offers the perfect
                  backdrop to pop the question. Every detail is curated to help
                  you create a moment you will both cherish forever.
                </p>
                <h3>
                  <strong>Proposal Picnic Inclusions</strong>
                </h3>
                <div className="proposals__picnic--inclusions-package">
                  <ul>
                    <li>Signature Cabana</li>
                    <li>Rugs & Cushions</li>
                    <li>Low lying beach chairs</li>
                    <li>
                      Picnic table with white table cloth, table runner,
                      candles, décor
                    </li>
                    <li>
                      Luxury table setting with plates, gold cutlery, pressed
                      napkins
                    </li>
                    <li>
                      Glassware - glass tumblers & designer champagne flutes
                    </li>
                    <li>Fresh Rose Petals</li>
                    <li>Fresh Flower Bouquet to keep</li>
                  </ul>
                  <ul>
                    <li>Neon table sign “it was always you”</li>
                    <li>Bose bluetooth speaker for your playlist</li>
                    <li>Setting decorated with artificial roses</li>
                    <li>
                      Natural rug with fresh rose petals for the 'pop the
                      question' moment
                    </li>
                    <li>
                      Ice bucket with complimentary ice and sparkling water
                      along with
                    </li>
                    <li>
                      A bottle of Chandon sparkling wine to toast to 'forever'
                    </li>
                    <li>Delicate box of chocolates</li>
                    <li>
                      Charcuterie platter for two - a selection of gourmet deli
                      meats,
                    </li>
                    <li>
                      cheeses, olives, fruit, nuts, dips, crackers & artisan
                      breads
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Proposal Package Images Row*/}
          <div className="proposals__picnic--image-container">
            <img
              src={proposalsPackage[0]?.src}
              alt={proposalsPackage[0]?.alt}
              className="proposals__picnic--image"
            ></img>
            <img
              src={proposalsPackage[1]?.src}
              alt={proposalsPackage[1]?.alt}
              className="proposals__picnic--image"
            ></img>
            <img
              src={proposalsPackage[2]?.src}
              alt={proposalsPackage[2]?.alt}
              className="proposals__picnic--image"
            ></img>
            <img
              src={proposalsPackage[3]?.src}
              alt={proposalsPackage[3]?.alt}
              className="proposals__picnic--image"
            ></img>
          </div>
        </div>
      </section>

      {/* Proposal Guide */}
      <section className="proposals__guide--container-main">
        <div className="proposals__guide--container">
          <div className="proposals___guide--heading">
            <h2>Step-by-Step Guide to Proposing During the Proposal Picnic</h2>
          </div>
          <div className="proposals__guide--details-item">
            <h3>1. Plan the Details (1-2 weeks ahead)</h3>
            <ul className="proposals__guide--details-list">
              <li>
                Book your proposal picnic early (you're already there - great
                start).
              </li>
              <li>
                Choose the setup: Teepee, cabana, or open sky - go with what
                suits your partner's style best.
              </li>
              <li>
                Select a date & time: Sunset is a classic (soft light = romance
                + great photos).
              </li>
              <li>
                Add extras: Fresh flower bouquet, photographer, champagne, or
                custom sign to personalise the experience.
              </li>
            </ul>
          </div>

          <div className="proposals__guide--details-item">
            <h3>2. Personal Touches (before the day)</h3>
            <ul className="proposals__guide--details-list">
              <li>
                Write a short speech or message you want to say before proposing
                (keep it heartfelt and true to your relationship).
              </li>
              <li>
                Choose a playlist with songs that mean something to both of you.
              </li>
              <li>
                Confirm with your photographer (if you booked one) where they'll
                be and how they'll capture the moment discreetly.
              </li>
              <li>
                Double-check the weather forecast and bring an umbrella or
                jacket if needed (just in case).
              </li>
            </ul>
          </div>

          <div className="proposals__guide--details-item">
            <h3>3. The Day Of</h3>
            <ul className="proposals__guide--details-list">
              <li>
                Arrive slightly early (or coordinate with the picnic
                stylist/photographer if it's a surprise).
              </li>
              <li>
                Ensure the ring is secure and hidden somewhere easy to access.
              </li>
            </ul>
          </div>

          <div className="proposals__guide--details-item">
            <h3>4. The Proposal Moment</h3>
            <ul className="proposals__guide--details-list">
              <li>
                Start by enjoying the picnic—chat, relax, play music, snack a
                little.
              </li>
              <li>
                When it feels right (and you'll feel it), shift the mood
                slightly—maybe stand up, take her hand, or ask her to walk over
                to the sign.
              </li>
              <li>Say your prepared words or speak from the heart.</li>
              <li>Get down on one knee, open the ring box, and ask:</li>
              <li>“Will you marry me?”</li>
              <li>Let the moment breathe. Don't rush.</li>
            </ul>
          </div>

          <div className="proposals__guide--details-item">
            <h3>5. After She Says Yes</h3>
            <ul className="proposals__guide--details-list">
              <li>Toast with the champagne or sparkling water.</li>
              <li>Give her the fresh floral arrangement to hold.</li>
              <li>Take a few photos—with or without a photographer.</li>
              <li>
                Let her soak it all in—this is a once-in-a-lifetime memory.
              </li>
            </ul>
          </div>

          <div className="proposals__guide--details-item">
            <h3>6. Optional: Celebrate Further</h3>
            <ul className="proposals__guide--details-list">
              <li>
                Have a post-proposal dinner or meet-up planned (even just the
                two of you).
              </li>
              <li>
                Send a photo or video to family/friends if they weren't there.
              </li>
              <li>
                Plan a keepsake—like framing the sign, flowers, or photos from
                the day.
              </li>
            </ul>
            <h4>Proposal Tip:</h4>
            <p>
              Stay present. Things might not go exactly as planned - and that's
              okay. What is remembered most is how you made them feel in that
              moment. Remember to breathe.
            </p>
          </div>

          <div className="proposals__guide--details-item">
            <h3>Inspirational Proposal Speech </h3>
            <p>
              Take their hand, or wait until you're both sitting quietly. Look
              into their eyes, take a breath, and begin…
            </p>
            <ul className="proposals__guide--details-list">
              <li>
                I've been thinking about this moment for a long time. And now
                that we're here, just us, in this beautiful place - it feels
                like the perfect moment to tell you something that's been on my
                heart every single day.
              </li>
              <li>
                From the moment you came into my life, everything felt
                different. Better. Brighter. I've never known a love like
                this—so real, so grounding, and so full of joy.
              </li>
              <li>
                You are my best friend, my favourite person, and the one I want
                to share everything with — from the biggest dreams to the quiet,
                everyday moments.
              </li>
              <li>
                I can't imagine a future without you in it. And I don't want to.
              </li>
              <li>(Now slowly kneel and open the ring box…)</li>
              <li>So today, with all my heart, I'm asking you - </li>
              <li>"Will you marry me?”</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Proposals;
